import type { BookingOffering } from "./api.js";

export type TutorFundingMode = "lesson_credit" | "payment_pending";

export function offeringKey(
  offering: Pick<BookingOffering, "provider_id" | "service_id">,
): string {
  return `${offering.provider_id}:${offering.service_id}`;
}

export function fundingModes(offering: BookingOffering): TutorFundingMode[] {
  const modes: TutorFundingMode[] = [];
  if (offering.book_with_credit.allowed) modes.push("lesson_credit");
  // `request_onsite` is the staff offerings contract's payment_pending
  // decision (tutorOneOffBooking.offerings), not the student endpoint's own
  // scope field. The staff mutation remains authoritative regardless: it
  // repeats scope checks and slot validation before creating an explicit
  // pending Amelia payment.
  if (offering.request_onsite.allowed) modes.push("payment_pending");
  return modes;
}

export function defaultFundingMode(offering: BookingOffering): TutorFundingMode | null {
  const modes = fundingModes(offering);
  if (modes.includes("lesson_credit")) return "lesson_credit";
  if (modes.includes("payment_pending")) return "payment_pending";
  return null;
}
